import { TeamFragment } from '$/GraphQL/schema/types';
import { createBackendUrl } from './urls';

export const createWebinarSetPurchasePixelUrl = (
  team: TeamFragment,
  ewebinarSetId: string
): string => {
  const path = `v1/conversion/pixel/${team.id}`;

  const params = {
    webinarId: ewebinarSetId,
    email: '{{email}}',
    amount: '{{amount}}',
    currency: '{{currency}}',
    orderId: '{{order_id}}',
    productId: '{{product_id}}',
    productName: '{{product_name}}',
  };

  return createBackendUrl(path, params, team).replace(/%7D/g, '}').replace(/%7B/g, '{');
};
